import { Box, Grid, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import CustomModal from "../Modal";

function EditModal({ children, modalOpen, setModalOpen, title, loading, onEdit, Icon, disabled }) {
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      {Icon &&
         <IconButton onClick={handleOpen} disabled={disabled}>
           {Icon}
         </IconButton>
      }

      <CustomModal open={modalOpen} handleClose={handleClose} title={title}>
        <Box py={2} px={{ md: 5, xs: 2 }}>
          <Grid container spacing={2} rowSpacing={3} sx={{ mt: 1 }}
                className="flex-column-md" justifyContent="center"
          >
            {children}

            <Grid item md={4} mt={2}>
              <LoadingButton
                color="info"
                loading={loading}
                startIcon={<EditIcon />}
                variant="outlined"
                fullWidth
                onClick={onEdit}
              >
                {title}
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
    </>
  )
}

export default EditModal;
